import { Chip as MuiChip, ChipProps as MuiChipProps, styled } from "@mui/material";

const StyledChip = styled(MuiChip)(() => {
  return {};
});

type ChipProps = MuiChipProps;

export const Pill: React.FC<ChipProps> = ({ ...props }) => {
  return <StyledChip {...props} />;
};

export default Pill;
